import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../../shared/shared.module';
import { ReportsService } from '../../../../shared/_services/reports.service';
import { AuditDashboardService } from '../../../../shared/_services/audit-dashboard.service';
import { ReportsRoutingModule } from './reports-routing.module';
import { ReportsComponent } from './reports/reports.component';
import { AuditDashboardComponent } from './audit-dashboard/audit-dashboard.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ReportsRoutingModule
  ],
  declarations: [ReportsComponent, AuditDashboardComponent],
  providers: [ReportsService, AuditDashboardService]
})
export class ReportsModule { }



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/reports/reports.module.ts